
const initialState = {
    toggle: false,
}

const reducer = (state = initialState, action) => {
  if (action.type === 'RENDER_PERMISSION_MODAL') {
      return {
        ...state,
        toggle: action.toggle,
      }
  }
  else
   return state
};

export default reducer;
 